// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-dashboard {
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 1.75em 0;
}
.user-dashboard .table-container {
  background-color: white;
  border-radius: 8px;
  min-width: 1000px;
  padding: 32px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Dashboards/UserDashboard/UserDashboard.less"],"names":[],"mappings":"AAEA;EACC,mBAAA;EACA,aAAA;EACA,OAAA;EACA,sBAAA;EACA,iBAAA;AADD;AAJA;EAQE,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;AADF","sourcesContent":["@import (reference) \"../../../Styles/colors\";\n\n.user-dashboard {\n\talign-items: center;\n\tdisplay: flex;\n\tflex: 1;\n\tflex-direction: column;\n\tpadding: 1.75em 0;\n\n\t.table-container {\n\t\tbackground-color: white;\n\t\tborder-radius: 8px;\n\t\tmin-width: 1000px;\n\t\tpadding: 32px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
